import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { MOCKUP_URL } from '../../data/images';
const included = ['6 volumes pédagogiques', '5 bonus', 'Accès numérique immédiat'];
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-charcoal px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-88" data-mp="9wzhp63hhpas">
      <div className="mx-auto max-w-4xl" data-id="element-89" data-mp="ivku0jid4834">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-butter" data-id="element-90" data-mp="iujgm8dvj9i8">
          Barber Instructor Ready™ — Édition française
        </p>
        <h2 id="final-heading" className="mx-auto mt-4 font-display text-[2.6rem] font-bold leading-[1.04] text-brand-ivory sm:text-[3.4rem]" data-id="element-91" data-mp="suagkpl7egpp">
          Vos prochains cours de barbering méritent{' '}
          <em className="font-display font-semibold italic text-brand-butter" data-id="element-92" data-mp="2ulwxtzfamx8z">une meilleure préparation.</em> 💈
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-ivory/75 sm:text-[16px]" data-id="element-93" data-mp="2pnvj1qowhk3b">
          Arrêtez de perdre des heures à organiser vos supports. Découvrez six volumes de ressources
          pédagogiques pour enseigner avec plus de structure et de confiance.
        </p>

        <img src={MOCKUP_URL} alt="Le système complet Barber Instructor Ready — Édition française" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(0, 0, 0, 0.35))'
      }} data-id="element-94" data-mp="2zgd0fely5gpl" />

        <CtaBlock label="Oui, je veux mes 6 volumes !" tone="dark" className="mt-10" data-id="element-95" data-mp="3j6yhymvkuzc6" />

        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-96" data-mp="3n6qwrhbke1pz">
          {included.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-ivory/70" data-id="element-97" data-mp="1ouigdzdq89dn">
              <CheckIcon className="h-3.5 w-3.5 text-brand-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-98" data-mp="1svu9ievt7cql" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}